const Shift = {
  symbol: 'shift',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }"  d="M20.52 16.42l4.478-4.478L16.056 3l-8.937 8.937H16l-.002.002H7.057l4.472 4.471.026-.026.006.006-4.49 4.488 8.943 8.943 8.943-8.943h-8.895 8.915l-4.456-4.459zm-4.471 4.457h-.014l.007-.006-.007.006h.014zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#964B9C"/><g fill="#FFF"><path opacity=".6" d="M20.507 16.406l-4.472 4.471h8.942l-4.47-4.471z"/><path opacity=".7" d="M11.528 16.41L16 11.94H7.057l4.472 4.471z"/><path opacity=".4" d="M16.035 20.878l4.46-4.46-4.48-4.482-8.943 8.942 8.942 8.943 8.943-8.943h-.002z"/><path opacity=".8" d="M16.056 3l-8.937 8.937H16l-4.446 4.446 4.502 4.501 8.942-8.942z"/></g></g>`;
  }
};
export default Shift;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/shift.js
// module id = null
// module chunks = 